import { render } from "./ProductFilter.vue?vue&type=template&id=50a29684&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"

import "./ProductFilter.vue?vue&type=style&index=0&id=50a29684&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a29684"]])

export default __exports__